module.exports = {
  CLIENT_ID: 'bvd3goeut3jtpofx7r99l5zu8gmdte',
  REDIRECT_URI: 'https://monthly-dev.drmc.gg/oauth/twitch',
};
